import { render } from "./MessageInline.vue?vue&type=template&id=1ddce7a4"
import script from "./MessageInline.vue?vue&type=script&lang=js"
export * from "./MessageInline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__